import { z } from 'zod';

const migratableAdvanceLogicSchema = z.looseObject({
  label: z.string().optional(),
});

const migratableWidgetSchema = z.looseObject({
  type: z.string().optional(),
  advanceLogics: z.array(migratableAdvanceLogicSchema).optional(),
  parameter: z.string().optional(),
  showName: z.boolean().optional(),
});

const migratableCanvasRectSchema = z.looseObject({
  id: z.string().optional(),
  parentId: z.string().nullable().optional(),
  level: z.number().optional(),
  childIds: z.array(z.string()).optional(),
  layoutDirection: z.enum(['vertical', 'horizontal']).optional(),
});

export const migratableTemplateContentSchema = z.looseObject({
  version: z.string(),
  canvas: z.record(z.string(), migratableCanvasRectSchema).optional(),
  widgets: z.record(z.string(), migratableWidgetSchema),
});

export type MigratableTemplateContent = z.infer<
  typeof migratableTemplateContentSchema
>;
